import React from 'react';
import styled from 'styled-components';
import searchIcon from '../../asset/icon/see.png';
import searchNotIcon from '../../asset/icon/see_not.png';
import HintSmallWrapper from '../../shared/component/headless/button/HintSmallWrapper';
import { getHintMessage } from '../../shared/constants/hintMessages';
import { AboutContentMode } from '../../shared/enum/EnumRepository';
import { useAboutPage } from '../../shared/hooks/page/useAboutPage';

const AboutTopBarFixed: React.FC = () => {
  const {
    isEditMode,
    canShowMember: canShow,
    memberInfo,
    engVisible,
    handleEngVisible,
    aboutContentMode,
    setAboutContentMode,
    isExtended,
    setIsExtended,
    isOwner,
  } = useAboutPage();

  return (
    <TopBar>
      <LanguageSelector>
        {(isEditMode || engVisible) && (
          <>
            <LanguageOption
              type="button"
              $isActive={aboutContentMode === AboutContentMode.Orig}
              onClick={() => setAboutContentMode(AboutContentMode.Orig)}
            >
              Orig
            </LanguageOption>
            <LanguageDivider>/</LanguageDivider>
            <LanguageOption
              type="button"
              $isActive={aboutContentMode === AboutContentMode.ENG}
              onClick={() => setAboutContentMode(AboutContentMode.ENG)}
            >
              ENG
            </LanguageOption>
          </>
        )}
        {isEditMode && canShow && memberInfo && (
          <>
            <LanguageDivider>|</LanguageDivider>
            <EngVisibilityIconWrap>
              <HintSmallWrapper
                content={
                  engVisible
                    ? getHintMessage('ABOUT_ENG_VISIBILITY_HIDE')
                    : getHintMessage('ABOUT_ENG_VISIBILITY_EXPAND')
                }
                toLeft={true}
              >
                <EngVisIconBtnWrapper onClick={() => void handleEngVisible(!engVisible)}>
                  <EngVisIconBtn $backgroundImg={engVisible ? searchIcon : searchNotIcon} />
                </EngVisIconBtnWrapper>
              </HintSmallWrapper>
            </EngVisibilityIconWrap>
          </>
        )}
      </LanguageSelector>
      {isOwner && <ToggleButton onClick={() => setIsExtended(!isExtended)}>
        {isExtended ? '<  >' : '<>'}
      </ToggleButton>}
    </TopBar>
  );
};

export default AboutTopBarFixed;

const TopBar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  width: 100%;
  margin-top: 18px;
`;

const LanguageSelector = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const EngVisibilityIconWrap = styled.span`
  display: inline-flex;
  align-items: center;
`;

const EngVisIconBtnWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.color_Alpha_03};
  &:hover {
    transform: scale(1.1);
  }
  transition: all 0.3s ease-in-out;
  cursor: pointer;
`;

const EngVisIconBtn = styled.div<{ $backgroundImg: string }>`
  width: clamp(12px, 2vw, 14px);
  height: clamp(12px, 2vw, 14px);
  background-image: url(${({ $backgroundImg }) => $backgroundImg});
  background-size: cover;
  background-position: center;
`;

const LanguageOption = styled.button<{ $isActive: boolean }>`
  ${({ theme }) => theme.typography.Footer_01};
  color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.color_Gray_04 : theme.colors.color_Gray_05};
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: color 0.2s ease;
  padding: 0;

  &:hover {
    color: ${({ theme }) => theme.colors.color_Gray_04};
  }
`;

const LanguageDivider = styled.span`
  ${({ theme }) => theme.typography.Footer_01};
  color: ${({ theme }) => theme.colors.color_Gray_05};
  user-select: none;
`;

const ToggleButton = styled.div`
  ${({ theme }) => theme.typography.Footer_01};
  color: ${({ theme }) => theme.colors.color_Gray_05};
  cursor: pointer;
`;
